import React, { useEffect, useMemo, useState } from 'react';

function readToken() {
  return new URLSearchParams(window.location.search).get('token') || '';
}

export default function RoadmapEmailActionPage() {
  const token = useMemo(() => readToken(), []);
  const [status, setStatus] = useState(token ? 'loading' : 'error');
  const [error, setError] = useState(token ? '' : 'This roadmap link is not valid.');
  const [action, setAction] = useState(null);

  useEffect(() => {
    if (!token) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const response = await fetch(`/api/roadmap-email-action?token=${encodeURIComponent(token)}`, {
          headers: { Accept: 'application/json' },
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.error || 'Could not open this roadmap link.');
        if (cancelled) return;
        setAction(data);
        setStatus('ready');
      } catch (err) {
        if (cancelled) return;
        setError(err.message || 'Could not open this roadmap link.');
        setStatus('error');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  const confirm = async () => {
    setStatus('saving');
    setError('');
    try {
      const response = await fetch('/api/roadmap-email-action', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ token }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.error || 'Could not update that grant.');
      setAction(data);
      setStatus('done');
    } catch (err) {
      setError(err.message || 'Could not update that grant.');
      setStatus('ready');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 px-6 py-16">
      <div className="mx-auto max-w-md rounded-xl border border-gray-100 bg-white p-6">
        <p className="text-xs font-medium uppercase tracking-wide text-gray-500">Earnings roadmap</p>
        {status === 'loading' || status === 'saving' ? (
          <div className="mt-6 space-y-3">
            <div className="h-4 w-2/3 animate-pulse rounded bg-gray-100" />
            <div className="h-3 w-full animate-pulse rounded bg-gray-100" />
          </div>
        ) : null}
        {status === 'error' ? (
          <p className="mt-4 text-sm text-gray-600">{error}</p>
        ) : null}
        {action && status !== 'loading' ? (
          <div className="mt-4">
            <h1 className="text-xl font-semibold tracking-tight text-gray-900">{action.grantName}</h1>
            {action.toStatus ? (
              <p className="mt-2 text-sm text-gray-600">
                {action.action} moves this grant from {action.fromStatus} to {action.toStatus}.
              </p>
            ) : (
              <p className="mt-2 text-sm text-gray-600">
                {action.grantName} is already at {action.fromStatus}, the end of this priority list.
              </p>
            )}
            {error ? <p className="mt-3 text-sm text-red-600">{error}</p> : null}
            {status === 'done' ? (
              <p className="mt-4 text-sm font-medium text-gray-900">Updated to {action.toStatus}.</p>
            ) : null}
            {status === 'ready' && action.canApply ? (
              <button
                type="button"
                onClick={confirm}
                className="mt-6 inline-flex items-center rounded-lg bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-800 transition-colors"
              >
                {action.action}
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}
